<template>
    <div style="margin-top:20px;">
        <div class="api_title">
            <h2>返回码</h2>
            <a-button type="primary" class="errorAddBtn" @click="handleAddError">新增</a-button>
        </div>

        <a-table style="margin-top:20px;" :columns="columns" :data-source="errorInfoList" :pagination="false" rowKey="errorCode">
            <template slot="operation" slot-scope="text, record">
                <span>
                    <a-button
                        type="link"
                        class="but_type"
                        style="right:10px;"
                        @click="()=> edit(record)"
                    >编辑
                    </a-button>
                    <a-popconfirm @confirm="() => handle_error_delete(record)">
                        <template slot="title">
                            <p>{{ '确认将【' + record.errorCode+ '】删除？' }}</p>
                        </template>
                        <a>删除 </a>
                    </a-popconfirm>
                </span>
            </template>
        </a-table>

        <a-modal title="返回码" :width="600" :visible="errorEditVisible" @ok="handleAddOK" @cancel="handleAddCancle">
            <a-tabs v-model="tabKey">
                <a-tab-pane key="1" tab="输入返回码">
                    <a-form-model :model="myForm"  ref="myCodeForm" :rules="rules" :layout="formItemLayout">
                        <a-form-model-item ref="mycode" label="返回码" prop="mycode">
                            <a-input  v-model="myForm.mycode" :disabled="page_type == 'edit'" placeholder="返回码"
                                @blur="() => {$refs.mycode.onFieldBlur();}" />
                        </a-form-model-item>

                        <a-form-model-item ref="mymsg" label="描述" prop="mymsg">
                            <a-input type="textarea" v-model="myForm.mymsg" placeholder="描述" @blur="() => {$refs.mymsg.onFieldBlur();}" />
                        </a-form-model-item>

                        <a-form-model-item ref="mysolution" label="解决方案" prop="mysolution">
                            <a-input type="textarea" v-model="myForm.mysolution" placeholder="解决方案" @blur="() => {$refs.mysolution.onFieldBlur();}" />
                        </a-form-model-item>
                    </a-form-model>
                </a-tab-pane>
                <a-tab-pane key="2" tab="JSON数组" v-if="page_type == 'add'">
                    <editor v-model="jsonData" @init="editorInit" lang="json" theme="monokai" :options="aceOps" width="100%" height="300"></editor>
                </a-tab-pane>
        
            </a-tabs>
            
        </a-modal>
    </div>
</template>
<script>
import Editor from 'vue2-ace-editor'
import {
    formatJson,
} from "@/utils/data_format_utils";
const columns = [
    
    {
        title: "返回码",
        width:100,
        dataIndex:"errorCode",
        align: "center",
        ellipsises:true
    },
    {
        title: "描述",
        width:150,
        dataIndex:"errorMsg",
        align: "center",
    },
    {
        title: "解决方案",
        width:150,
        dataIndex:"solution",
        align: "center",
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 50,
        scopedSlots: {
            customRender: 'operation'
        },
    }
   
];
const defaultJSON = [
    {
        errorCode:'1001',
        errorMsg:'-异常信息-',
        solution:'-解决方案-'
    }
]
export default {
    components:{
        Editor
    },
    data() {
        return {
            page_type:'add',
            tabKey:'1',
            columns,
            errorInfoList:[],
            errorEditVisible:false,
            myForm:{
                mycode:'',
                mymsg:'',
                mysolution:''
            },
            jsonData:formatJson(defaultJSON),
            aceOps:{
                wrap: true
            },
            rules: {
                mycode: [
                    { required: true, message: ' 请输入异常编码 ', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                mymsg: [
                    { required: true, message: ' 请输入异常信息 ', trigger: 'blur' },
                    { min: 1, max: 200, message: '请输入1~200个字符', trigger: 'blur' },
                ],
                mysolution:[
                    { required: true, message: ' 请输入解决方案 ', trigger: 'blur' },
                    { min: 1, max: 200, message: '请输入1~200个字符', trigger: 'blur' },
                ],
            },
            formItemLayout:'horizontal',
        };
    },
 
    methods: {
        handle_error_delete(record){
            this.errorInfoList = this.errorInfoList.filter(item => { return item.errorCode != record.errorCode })
        },
        editorInit() {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/json')    //language
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        edit(record){
            this.page_type = 'edit';
            this.myForm.mycode = record.errorCode;
            this.myForm.mymsg = record.errorMsg;
            this.myForm.mysolution = record.solution;
            this.errorEditVisible = true;
        },
        handleAddError(){
            this.page_type = 'add';
            this.myForm.mycode = '';
            this.myForm.mymsg = '';
            this.myForm.mysolution = '';
            this.errorEditVisible = true;
        },
        handleAddCancle(){
            this.myForm.mycode = '';
            this.myForm.mymsg = '';
            this.myForm.mysolution = '';
            this.errorEditVisible = false;
        },
        handleAddOK(){
            //提交
            let that = this;
            if(this.tabKey == 1){
                that.$refs.myCodeForm.validate(valid => {
                    if (valid) {
                        let result = [];
                        result.push({
                            errorCode:that.myForm.mycode,
                            errorMsg:that.myForm.mymsg,
                            solution:that.myForm.mysolution
                        })
                        that.postJson(result)
                    } else {
                        return false;
                    }
                });
            }
            else{
                console.log(that.jsonData);
                try {
                    let result = JSON.parse(that.jsonData)
                    that.postJson(result)
                } catch (error) {
                    that.message.error('JSON格式校验失败');
                }
                
            }
        },
        postJson(targetList){
            //校验重复
            if(this.page_type == 'add'){
                let haveSame = false;
                let currentList = this.errorInfoList;
                currentList = currentList.concat(targetList);
                let sameCode = '';
                currentList.forEach(element => {
                    let sameList = currentList.filter(item => { return item.errorCode == element.errorCode });
                    if(sameList.length > 1){
                        haveSame = true;
                        sameCode = element.errorCode
                        return false;
                    }
                });
                if(haveSame){
                    this.message.error('errorCode重复  ' + sameCode);
                }
                else{
                    this.errorInfoList = currentList;
                    this.$emit('handleErrorDataChange',this.errorInfoList);
                    this.errorEditVisible = false;
                }
            }
            else{
                //编辑
                this.errorInfoList.forEach(element => {
                    if(element.errorCode == targetList[0].errorCode){
                        element.errorMsg = targetList[0].errorMsg;
                        element.solution = targetList[0].solution;
                    }
                });
                this.$emit('handleErrorDataChange',this.errorInfoList);
                this.errorEditVisible = false;
            }
            
            
        },
        
    },
    mounted(){
    },
    props:{
        errorinfos:String
    },
    watch:{
        'errorinfos'(newVal){
            if(newVal){
                this.errorInfoList = JSON.parse(newVal)
            }
        }
    }
};
</script>

<style scoped>
.api_title{
        clear: both;
        font-weight: 400;
        margin-top: .48rem;
        margin-bottom: .16rem;
        border-left: 3px solid #2395f1;
        padding-left: 16px;
        background: #f7f8fa;
        padding-top: 8px;
        padding-bottom: 8px;
        position: relative;
    }

    .api_title h2{
        padding: 0;
        margin: 0;
    }

    .errorAddBtn{
        position: absolute;
        top:8px;
        right: 10px;
    }

</style>
